<script>
import { BTime } from "bootstrap-vue";

export default {
  extends: BTime
};
</script>